enum BetBuilderTextKeys {
	MODAL_HEADER_LABEL = 'SPORTSBOOK_BET_BUILDER_MODAL_HEADER_LABEL'
}

export default BetBuilderTextKeys;
